var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2946 3.92202C17.2054 2.85211 15.8898 2.04049 14.4449 1.54708C13 1.05367 11.4627 0.891061 9.9466 1.07127C8.43046 1.25147 6.97415 1.76988 5.68518 2.58823C4.39621 3.40659 3.30748 4.50398 2.49938 5.7994C1.69128 7.09483 1.18443 8.55521 1.01626 10.0727C0.84809 11.5902 1.02288 13.1262 1.52774 14.5671C2.0326 16.008 2.85463 17.3172 3.93315 18.3979C5.01166 19.4786 6.31913 20.3033 7.75902 20.8111C8.12413 20.9341 8.5066 20.9979 8.89189 20.9999C9.79325 20.9999 10.6577 20.6418 11.295 20.0045C11.9324 19.3671 12.2905 18.5027 12.2905 17.6013V17.2331C12.2905 16.9327 12.4098 16.6445 12.6223 16.4321C12.8347 16.2196 13.1229 16.1003 13.4233 16.1003H17.7848C18.5558 16.1037 19.3048 15.8434 19.9076 15.3626C20.5103 14.8818 20.9305 14.2094 21.0985 13.4569C21.2779 12.6865 21.3635 11.8972 21.3534 11.1062C21.3442 9.76594 21.0691 8.44079 20.544 7.20757C20.019 5.97436 19.2544 4.8576 18.2946 3.92202Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9501,
    cy: 10.0908,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.83223,
    cy: 5.57808,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.8374,
    cy: 5.123,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.27217,
    cy: 10.5459,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.14949,
    cy: 16.0293,
    r: 0.454543,
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.d699b867ee6011c44a129c7afd6cbbec.svg";
export { ForwardRef as ReactComponent };